import React, { FC } from 'react';
import classNames from 'classnames';

import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import { TEXTS } from './texts';
import DiscountHint from './DiscountHint';

import ratesTableStyles from '../index.module.scss';
import styles from './index.module.scss';

interface PrimeDiscountProps {
  primeDiscountValue?: number | null;
  children?: React.ReactNode | undefined;
}

const PrimeDiscount: FC<PrimeDiscountProps> = ({ children, primeDiscountValue }) => {
  const { isDesktop } = useMedia();

  if (!primeDiscountValue) {
    return null;
  }

  return (
    <>
      <tr>
        <td className={ratesTableStyles.description}>{TEXTS.PRIME_POINT_COUNT}</td>

        <td className={classNames(ratesTableStyles.ratesTablePrice, styles.discount)}>
          <span className={styles.oldPrice}>{children}</span>
          <span className={styles.newPrice}>{`${primeDiscountValue} ${TEXTS.PRIME_PRICE}`}</span>
          {!isDesktop && <DiscountHint />}
        </td>
      </tr>

      {isDesktop && <DiscountHint />}
    </>
  );
};

export default React.memo(PrimeDiscount);
